import { GREY_400, Text } from '@mnd-frontend/ui';
import styled from 'styled-components';
import imageSize from '../../img/image-size.gif';

export const ImgWrapper = styled.div`
  background: ${GREY_400};
  padding: 1rem;
  margin-top: 1rem;

  img {
    box-shadow:
      0px 6px 10px rgba(49, 73, 164, 0.08),
      0px 0px 3px rgba(49, 73, 164, 0.1),
      0px 0px 2px rgba(49, 73, 164, 0.14);
    width: 100%;
  }
`;

const CoverPhoto = () => (
  <>
    <Text as="h3" variant="headlineSmall">
      Picking the perfect cover photo
    </Text>
    <Text as="h4" variant="labelMedium">
      Go wide
    </Text>
    <Text as="p" variant="body">
      To ensure that your story looks perfect in emails, social shares and in your newsroom, go for
      a landscape image <strong>(16:9 aspect ratio)</strong> instead of a portrait image.
    </Text>
    <ImgWrapper>
      <img src={imageSize} alt="size example" />
    </ImgWrapper>
    <Text as="h4" variant="labelMedium" marginTop="SPACING_3">
      Make it big
    </Text>
    <Text as="p" variant="body">
      Small images have a tendency to look blurry on large screens so use larger images instead.
      Image sizes are usually measured in pixels - we recommend using at least{' '}
      <strong>1280x720 pixels.</strong>
    </Text>
    <Text as="h4" variant="labelMedium" marginTop="SPACING_3">
      Preview first
    </Text>
    <Text as="p" variant="body">
      Preview your story before going live. Then you’ll see if the cover photo looks great, or if
      you need to make adjustments.
    </Text>
  </>
);

export default CoverPhoto;
